export default {"src":"/komodo/_next/static/media/desktop.b85c1b3e.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};